"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoadReadinessCheckerSLI = void 0;
var _useCommonPageActionsApi = require("../../client/react/useCommonPageActionsApi");
var _reactRouterDom = require("react-router-dom");
var useLoadReadinessCheckerSLI = exports.useLoadReadinessCheckerSLI = function useLoadReadinessCheckerSLI() {
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    startLoadReadinessChecker = _useCommonPageActions.startLoadReadinessChecker,
    endLoadReadinessChecker = _useCommonPageActions.endLoadReadinessChecker;
  var match = (0, _reactRouterDom.useRouteMatch)();

  /**
   * This function is used to start the Load Readiness Checker SLI when the Join page is first loaded.
   * @param {string} attendeeName - The name of the attendee.
   * @returns {void}
   */
  var startLoadReadinessCheckerSLI = function startLoadReadinessCheckerSLI(attendeeName) {
    startLoadReadinessChecker({
      attendeeName: attendeeName,
      pathName: match.path,
      url: match.url
    });
  };

  /**
   * This function is used to end the Load Readiness Checker SLI when the sandbox meeting is either created successfully or it results in a failure.
   * If no failure message is provided, we end the SLI as success else we end it as failure.
   * @param {string} failureMessage - The string may contain an error message in case of failure
   * @returns {void}
   */
  var endLoadReadinessCheckerSLI = function endLoadReadinessCheckerSLI(failureMessage) {
    if (!failureMessage) endLoadReadinessChecker({});else endLoadReadinessChecker({
      error: failureMessage
    });
  };
  return {
    startLoadReadinessCheckerSLI: startLoadReadinessCheckerSLI,
    endLoadReadinessCheckerSLI: endLoadReadinessCheckerSLI
  };
};